import { configureStore } from '@reduxjs/toolkit';
import storeSynchronize from 'redux-localstore';
import {
  teamsSlice, playersSlice, gameSlice, youtubeSlice, guestListSlice, historySlice,
} from './slices';

export const store = configureStore({
  reducer: {
    teams: teamsSlice.reducer,
    players: playersSlice.reducer,
    game: gameSlice.reducer,
    youtube: youtubeSlice.reducer,
    guestList: guestListSlice.reducer,
    history: historySlice.reducer,
  },
});

// O redux-localstore regrava o localStorage a cada ação. Quem for substituir o localStorage
// por fora (importar/restaurar backup) deve parar a sincronização antes, senão a próxima ação
// sobrescreve o que foi importado.
export const stopStoreSync = storeSynchronize(store, {
  whitelist: ['teams', 'players', 'game', 'guestList', 'history'],
  blacklist: [],
});
